"use client";

import { useContext } from "react";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutlined";
import { Box, Button, Typography } from "@mui/material";
import Link from "next/link";
import { ErrorBoundaryContext } from "react-error-boundary";
import Module from "../module/Module";
import styles from "./ModuleErrorFallback.module.scss";
import { useAtomValue } from "jotai";
import { greyState } from "@/lib/store";

const ModuleErrorFallback = () => {
    const grey = useAtomValue(greyState);
    // As in ErrorFallback: survive being rendered outside an ErrorBoundary (#1286).
    const resetBoundary = useContext(ErrorBoundaryContext)?.resetErrorBoundary;

    return (
        <Module noHeader>
            <div className={styles.fallback}>
                <Box sx={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: "center" }}>
                    <Box sx={{ height: "80%", display: "flex", flexDirection: "column", justifyContent: "center" }}>
                        <ErrorOutlineIcon style={{ fontSize: 40, marginLeft: "auto", marginRight: "auto" }} />
                        <Typography variant="h1" component="h2">
                            Something went wrong
                        </Typography>
                        <Typography variant="body2">Please refresh the page or try again later </Typography>
                        <Box className={styles.actions}>
                            <Button variant="outlined" sx={{ mb: 0.5, "&:disabled": { color: grey, border: `1px solid ${grey}` } }} size="small" disabled={!resetBoundary} onClick={resetBoundary}>
                                Try again
                            </Button>
                        </Box>
                    </Box>
                    <Typography variant="body1" sx={{ mb: 1 }}>
                        If the problem persists, please contact us at&nbsp;
                        <Link passHref legacyBehavior href="mailto:sales@ortex.com">
                            <Typography variant="body1" component="span" sx={{ color: "var(--accent-text, #31aba6)", cursor: "pointer" }}>
                                support@ortex.com
                            </Typography>
                        </Link>
                    </Typography>
                </Box>
            </div>
        </Module>
    );
};

export default ModuleErrorFallback;
